import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlightPipe } from './highlight.pipe';
import { XsI18nPipe } from './xs-i18n.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { TimeFormatPipe } from './time-format.pipe';
import { MatSelectToolTipDisabledPipe } from './xs-matselecttooltipdisabled.pipe';
import { SaI18nPipe } from './sa-i18n.pipe';
import { FileSizeFormatPipe } from './file-size-format.pipe';
import { XsI18nDatePipe } from './xsI18nDate.pipe';
import { XsImagePipe } from './xs-image.pipe';
import { LsImagePipe } from './ls-image.pipe';
import { TruncatePipe } from './truncate.pipe';
import { BatteryStatusPipe } from './battery-status.pipe';

export {
  XsI18nPipe,
  SaI18nPipe,
  TimeFormatPipe,
  MatSelectToolTipDisabledPipe,
  FileSizeFormatPipe,
  XsI18nDatePipe,
  XsImagePipe,
  LsImagePipe,
  TruncatePipe,
  BatteryStatusPipe
};

@NgModule({
  imports: [CommonModule, TranslateModule],
  declarations: [
    FileSizeFormatPipe,
    HighlightPipe,
    MatSelectToolTipDisabledPipe,
    SaI18nPipe,
    TimeFormatPipe,
    XsI18nDatePipe,
    XsI18nPipe,
    XsImagePipe,
    LsImagePipe,
    TruncatePipe,
    BatteryStatusPipe
  ],
  exports: [
    FileSizeFormatPipe,
    HighlightPipe,
    MatSelectToolTipDisabledPipe,
    SaI18nPipe,
    TimeFormatPipe,
    XsI18nDatePipe,
    XsI18nPipe,
    XsImagePipe,
    LsImagePipe,
    TruncatePipe,
    BatteryStatusPipe
  ],
  providers: [
    FileSizeFormatPipe,
    MatSelectToolTipDisabledPipe,
    SaI18nPipe,
    TimeFormatPipe,
    XsI18nDatePipe,
    XsI18nPipe,
    XsImagePipe,
    LsImagePipe,
    TruncatePipe,
    BatteryStatusPipe
  ],
})
export class PipesModule { }
